import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetCoachBookingList } from "../../../utilities/api/coachingBooking";
import { initialColumns } from "../../../modules/booking/CoachingSessionBooking/coachbooking.utils";
import { messages } from "../../../utilities/Messages";

type ErrorMessageType = {
  message: string;
}

type CoachingBookingListType = {
  id: string;
  name: string;
  contact: string;
  sessionName: string;
  sportName: string;
  noOfSessionToAttend: string;
  remainingSessions: string;
  days: string;
  startDate: string;
  endDate: string;
  totalAmount: string;
  status: string;
  bookingStatus: string;
  coachName: string;
  rawData: any;
  hash: string;
};

const initialState = {
  currentPage: 0,
  rowsPerPage: 0,
  totalPage: 0,
  totalRows: 0,
  AllCoachBookingData: [] as CoachingBookingListType[],
  coachingColumns: initialColumns,
  errorMessage: {} as ErrorMessageType,
};

export const AllCoachingBookingList = createAsyncThunk(
  "CoachingBooking/AllCoachingBookingList",
  (payload: any) => GetCoachBookingList(payload)
);

const CoachingBookingListSlice = createSlice({
  name: "CoachingBookingList",
  initialState,
  reducers: {
    setCoachingColumn: (state: any, action: any) => {
      state.coachingColumns = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(
        AllCoachingBookingList.fulfilled,
        (state, action: PayloadAction<any>) => {
          if (action?.payload?.statusCode === 200) {
            let data = action?.payload?.data;
            state.rowsPerPage = data?.limit;
            state.currentPage = data?.page;
            state.totalPage = data?.totalPages;
            state.totalRows = data?.totalRows;
            state.AllCoachBookingData = data?.rows?.map?.(
              (item: any, index: number) => ({
                srNo: index + 1,
                id: item?.id,
                name: `${item?.user?.firstName} ${item?.user?.lastName}`,
                contact: item?.user?.phone,
                sessionName: item?.sessionName,
                sportName: item?.sportName,
                noOfSessionToAttend: item?.noOfSessionToAttend,
                remainingSessions: item?.remainingSessions,
                startDate: item?.startDate,
                endDate: item?.endDate,
                totalAmount: Math.round(item?.totalAmount),
                status: item?.bookingPayments?.[0]?.payment?.status,
                bookingStatus: item?.status,
                coachName: `${item?.coach?.firstName} ${item?.coach?.lastName}`,
                paymentStatus: item?.paymentStatus,
                noOfDays: item?.noOfDays,
                facilityName: item?.facilityName,
                rawData: item,
                hash: item?.hash,
              })
            );
          }
        }
      )
      .addCase(AllCoachingBookingList.rejected, (state, action) => {
        state.errorMessage = { message: messages.error.internal_server_error };
      });

  },
});

export default CoachingBookingListSlice.reducer;
export const { setCoachingColumn } = CoachingBookingListSlice.actions;
